import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, money } from "../../lib/api";
import { windowText } from "../../components/Countdown";

export default function GymDashboard() {
  const [academy, setAcademy] = useState(null);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    api.get("/wholesale/my-academy").then(({ data }) => setAcademy(data)).catch(() => {});
    api.get("/wholesale/orders").then(({ data }) => setOrders(data)).catch(() => {});
  }, []);

  const switchTo = async (id) => {
    await api.post("/wholesale/switch-academy", { academy_id: id });
    window.location.reload();
  };

  const stats = [
    { label: "Wholesale Orders", value: academy?.order_count ?? 0 },
    { label: "Total Units", value: academy?.total_units ?? 0 },
    { label: "Total Spend", value: money(academy?.total_spend ?? 0) },
  ];

  return (
    <div className="px-5 lg:px-8 py-8">
      <p className="font-mono text-emerald-400 uppercase tracking-widest text-xs">My Academy</p>
      <h1 className="font-heading font-black uppercase text-4xl text-white mt-1">{academy?.name || "…"}</h1>
      <p className="text-zinc-500 mt-1">{academy?.city}{academy?.state ? `, ${academy.state}` : ""}</p>
      {academy?.switchable?.length > 1 && (
        <div className="mt-4 flex flex-wrap gap-2" data-testid="academy-switcher">
          {academy.switchable.map((a) => (
            <button key={a.id} data-testid={`switch-academy-${a.id}`} onClick={() => a.id !== academy.id && switchTo(a.id)}
              className={`px-4 py-2 rounded-full text-xs font-mono uppercase tracking-wider border transition-colors ${a.id === academy.id ? "bg-emerald-500 border-emerald-500 text-black font-bold" : "border-white/15 text-zinc-300 hover:border-emerald-400"}`}>
              {a.name}
            </button>
          ))}
        </div>
      )}

      <div className="grid grid-cols-3 gap-4 mt-6">
        {stats.map((s) => (
          <div key={s.label} className="bg-[#121216] border border-white/10 rounded-lg p-5">
            <p className="font-mono text-xs uppercase tracking-widest text-zinc-500">{s.label}</p>
            <p className="font-heading font-black text-3xl text-white mt-2">{s.value}</p>
          </div>
        ))}
      </div>

      <div className="grid md:grid-cols-2 gap-4 mt-6">
        <Link to="/gym/catalog" className="bg-emerald-500/10 border border-emerald-500/30 rounded-lg p-6 hover:bg-emerald-500/15 transition-colors">
          <h3 className="font-heading font-bold uppercase text-xl text-white">Start New Order</h3>
          <p className="text-zinc-400 text-sm mt-1">Browse the wholesale catalog and configure academy gear.</p>
        </Link>
        <Link to="/gym/orders" className="bg-[#121216] border border-white/10 rounded-lg p-6 hover:border-white/25 transition-colors">
          <h3 className="font-heading font-bold uppercase text-xl text-white">Reorder</h3>
          <p className="text-zinc-400 text-sm mt-1">View order history and quickly reorder previous gear.</p>
        </Link>
      </div>

      <div className="bg-yellow-400/10 border border-yellow-400/30 rounded-lg p-4 mt-6 font-mono text-sm text-yellow-300">
        ● Paragon Winter '26 · {windowText()} · Wholesale: min 10 units per product · 3% card fee · no sales tax
      </div>

      <h2 className="font-heading font-bold uppercase text-2xl text-white mt-8 mb-4">Recent Orders</h2>
      <div className="space-y-3">
        {orders.slice(0, 5).map((o) => (
          <Link key={o.id} to="/gym/orders" className="flex justify-between items-center bg-[#121216] border border-white/10 rounded-lg p-4 hover:border-white/25">
            <div>
              <p className="font-mono font-bold text-emerald-400">{o.order_number}</p>
              <p className="text-xs text-zinc-500">{o.units} units · {o.status}</p>
            </div>
            <span className="font-mono font-bold text-white">{money(o.total)}</span>
          </Link>
        ))}
        {orders.length === 0 && <p className="text-zinc-600 font-mono text-sm">No orders yet.</p>}
      </div>
    </div>
  );
}
